<template>
<div>
  <div class="wrapper">
    <div class="row">
      <div class="col-lg-12">
        <div id="filters">
          <div class="search col-lg-12 col-md-12">
            <div class="row">
              <div class="col-lg-3 col-md-3 m-t-sm">
                <v-select
                  placeholder="Clients"
                  :options="f.clients"
                  label="name"
                  index="id"
                  multiple
                  v-model="filters['clients']"
                ></v-select>
              </div>
              <div class="col-lg-3 col-md-3 m-t-sm">
                <v-select
                  placeholder="Status"
                  :options="statuses"
                  label="label"
                  index="index"
                  multiple
                  v-model="filters['status']"
                ></v-select>
              </div>
              <div class="col-lg-3 col-md-3 m-t-sm">
                <div class="display-flex">
                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 side-input-text pretty-input ">Completed</div>
                  <input type="date" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" v-model="filters['dateFrom']" placeholder="From">
                  <input type="date" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" v-model="filters['dateTo']" placeholder="To">
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 m-t-sm">
            <button class="btn btn-xs btn-primary" @click="generateReport">Generate</button>
            <button class="btn btn-xs btn-primary" @click="generateReport(true)"><i class="fa fa-download"></i> Csv</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>Order Id</th>
            <th>Campaign</th>
            <th>Client</th>
            <th>Site</th>
            <th>Link</th>
            <th>Anchor</th>
            <th>Status</th>
            <th>Completed</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="row in rows" :key="row.id">
            <td>{{ row.orderId }}</td>
            <td>{{ row.campaignName }}</td>
            <td>{{ row.clientName }}</td>
            <td>{{ row.websiteUrl }}</td>
            <td>{{ shorten(row.linkUrl, 30) }}</td>
            <td>{{ row.anchor }}</td>
            <td>{{ row.status }}</td>
            <td>{{ row.completionDate | aTime('DD.MM.YYYY') }}</td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import axios from 'axios'
import { Browser, Query, String } from '../../../../mixins/helperMixin'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      filters: {},
      rows: [],
      statuses: [
        {label: 'Completed', index: 'Completed'},
        {label: 'Content Ordered from Writer/WM', index: 'Content Ordered from Writer/WM'},
        {label: 'Content sent to Client for Approval', index: 'Content sent to Client for Approval'},
        {label: 'Contact WM', index: 'Contact WM'},
        {label: 'Cancelled', index: 'Canceled'}
      ]
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  mixins: [Query, String, Browser],
  methods: {
    generateReport (csv = false) {
      axios.get('/report/instalinko?' + this.buildQuery(this.filters), {
        headers: {
          'Accept': csv === true ? 'text/csv' : 'application/json'
        }
      })
        .then(r => {
          if (csv === true) {
            this.downloadFile('instalinko.csv', r.data.data)
          } else {
            this.rows = r.data.data
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Reports/Instalinko.vue